module.exports = __webpack_public_path__ + "static/media/bi.75d5af3d.svg";